import { Outlet } from "react-router";
import Header from "../../../component/layout/header";
import useNav from "../../../script/tabingNavArray";


const DealsOrganizationLayout = () => {
     const navList = useNav();
  let {dealOrgBottomNav, topDealNav} = navList;
    return (
        <div className="webBody">
            <Header bottomTabs={dealOrgBottomNav} topTabs={topDealNav} />
            <Outlet />
        </div>
    )
}

export default DealsOrganizationLayout;